
import React from "react"
import TemplateEditor from "../Pdfgenarot/Pdfgenator"
const Tempalte = ({Cropeiagmefile}) => {
    return (
        <>
        <div >
        <TemplateEditor Cropeiagmefile={Cropeiagmefile}/>
        </div>
  


        </>



    )
}

export default Tempalte;